var _rect, _circle, _circle2, _circle3, _circle4, _path, _path2, _circle5, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard7({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 334,
    viewBox: "0 0 388 334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 388,
    height: 334,
    rx: 24,
    fill: "#FFF4F4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 164.5,
    cy: 143.5,
    r: 5,
    stroke: "#BB3737"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.5,
    cy: 143.5,
    r: 5,
    stroke: "#BB3737"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 166.5,
    r: 5,
    stroke: "#BB3737"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.5,
    cy: 190.5,
    r: 5,
    stroke: "#BB3737"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.5 144H194.5",
    stroke: "#BB3737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M204.5 144C204.5 144 207 143.5 213 144C219 144.5 222.332 148.877 223 154.5C223.715 160.523 220 166.5 214.5 167.5C209 168.5 195.5 167.5 195.5 167.5",
    stroke: "#BB3737"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 191,
    r: 3.5,
    stroke: "#BB3737"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M185.5 167.5C185.5 167.5 176.5 167.5 173 167.5C169.5 167.5 162.142 173.635 162.5 180C162.819 185.667 169.5 191 172 191C174.5 191 177.5 191 177.5 191",
    stroke: "#BB3737"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188 191H216",
    stroke: "#BB3737"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M219 187.5V180.5M219 171V173M219 173H229.155C229.309 173 229.405 173.166 229.329 173.299L227.553 176.407C227.52 176.465 227.518 176.536 227.548 176.596L229.355 180.211C229.422 180.344 229.325 180.5 229.176 180.5H219M219 173V180.5",
    stroke: "#BB3737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard7);
export default __webpack_public_path__ + "static/media/Card7.a3fb2bce92f65c84bb63df3f7f17c7ce.svg";
export { ForwardRef as ReactComponent };